import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-redefine-footer',
    templateUrl: './redefine-footer.component.html',
    styleUrls: ['./redefine-footer.component.scss'],
})
export class RedefineFooterComponent {
    currentYear = new Date().getFullYear()

    constructor(private router: Router) {}

    viewAllProperties(): void {
        // No query param needed - map page detects enterprise from domain
        this.router.navigate(['/map-search'])
    }
}
